<div class="modal-header">
  <h5 class="modal-title">{{ 'maintenanceOverview.modals.breakdown.upcoming' | transloco }}</h5>
  <button type="button" class="btn-close" [attr.aria-label]="'common.close' | transloco" (click)="closeModal()">
    <i class="ph ph-x"></i>
  </button>
</div>

<div class="modal-body">
  <app-breakdown-analysis-table [data]="data" [isLoading]="isLoading"></app-breakdown-analysis-table>
</div>